define([
    "dojo/_base/declare",
    "csi/table/NewFrom",
    "csi/xml",
    "SiteAdmin/DataSheetForm"
], function(declare,NewFrom,xml,DataSheetForm) {

    return declare(NewFrom, {
        SUBTYPE: "Subtype",

        _getFormView: function(/*Node*/node, /*Boolean*/bCheckOnly) {
            // summary: add special controller for size chart copy form
            var defView = this.inherited(arguments);
            if (defView) {
                defView.classController = DataSheetForm;
            }

            return defView;
        },

         /**
         * @override
         * if action comes from "NewFromStyleSizeChart" call custom request else call request on the action
         * 
         */
        toWriter: function() {
            let call = this.inherited(arguments);

            const actionId = this.m_action.m_id;
            if (actionId == "NewFromStyleSizeChart") {
                const { m_formData } = this;
                const linkShapeSizeChart = m_formData.getFieldValue("LinkStyleSizeChartToShapeSizeChart", true);
                const sizeChartName = m_formData.getFieldValue(xml.ATTR_NAME, true);
                const subtype = m_formData.getFieldValue(this.SUBTYPE, true);
                const styleURL = this.m_nodeSource.__Parent__;
                const shape = this.m_urlParent;
                call.addParameter("FromStyle", xml.ATTR_STRING, styleURL)
                call.addParameter("SizeChartName", xml.ATTR_STRING, sizeChartName)
                call.addParameter("SizeChartSubtype", xml.ATTR_STRING, subtype)
                call.addParameter("NewNodeURL", xml.ATTR_CNL, this.m_urlNode)
                call.addParameter("LinkShapeSizeChart", xml.ATTR_BOOLEAN, linkShapeSizeChart)
                call.addParameter("ShapeURL", xml.ATTR_STRING, shape);
            }
            return call;
        },
    });
});